import './App.css';
import IMDBSearch from './containers/IMDBSearch/IMDBSearch'


function App() {




  return (
    <div className="App">
        <IMDBSearch />
    </div>
  );
}

export default App;
